import React from 'react';

const FilterCard = (props) => {
  return (
    <div className="filter-card h-100">
      <div className="filter-card__body">
        <div className="filter-card__label">{props.desc}</div>
        {props.kpi2 !== '' ? (
          <div className="filter-card__value">
            <div>{props.kpi1}</div>
            <div className="filter-card__sep">to</div>
            <div>{props.kpi2}</div>
          </div>
        ) : (
          <div className="filter-card__value">{props.kpi1}</div>
        )}
      </div>
    </div>
  );
};

export default FilterCard;
